import React from 'react';
import { siteContent } from '../data/mock';

const ProductDemoSection = () => {
  const { productDemo } = siteContent;

  return (
    <section className="product-demo-section section-padding" data-testid="product-demo-section" data-reveal="subtle">
      <div className="container">
        <div className="product-demo-content">
          <h2 className="section-title-center" data-testid="product-demo-title">{productDemo.title}</h2>
          <p className="product-demo-subtitle">{productDemo.subtitle}</p>

          {productDemo.visualization && (
            <div className="visualization-scenes">
              <p className="visualization-scene">{productDemo.visualization.morning}</p>
              <p className="visualization-scene">{productDemo.visualization.evening}</p>
            </div>
          )}

          <p className="product-demo-description">{productDemo.description}</p>

          <div className="product-demo-images">
            <img
              src="https://customer-assets.emergentagent.com/job_33a339f4-f49a-4e04-b255-5cd6c2784072/artifacts/tpxdpcld_Captura%20de%20tela%202026-02-07%20222640.png"
              alt="Comunidade A,Ê! — Página principal do Vivos no Espírito"
              className="demo-screenshot"
              data-testid="demo-image-1"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_33a339f4-f49a-4e04-b255-5cd6c2784072/artifacts/2g82ejwn_Captura%20de%20tela%202026-02-07%20222748.png"
              alt="Comunidade A,Ê! — Trilhas de conteúdo"
              className="demo-screenshot"
              data-testid="demo-image-2"
            />
          </div>

          <div className="product-demo-features">
            {productDemo.features.map((feature, index) => (
              <div key={index} className="product-demo-feature" data-testid={`product-demo-feature-${index}`}>
                <span className="feature-marker" aria-hidden="true"></span>
                <p>{feature}</p>
              </div>
            ))}
          </div>

          <p className="product-demo-closing">{productDemo.closingNote}</p>
        </div>
      </div>
    </section>
  );
};

export default ProductDemoSection;
